<script setup lang="ts">
/**
 * BON06 — Section 76 Notice (Secretary) + Lodger.
 * Word 템플릿 `Section 76 Notice (Secretary).docx` 문장 구조에 맞춤.
 */
import { computed, inject } from 'vue';
import { BONUS_DOC_CTX } from './bonusContext';
import BonusDocVarField from './BonusDocVarField.vue';

const ctx = inject(BONUS_DOC_CTX)!;
const grant = computed(() => ctx.flag('grant_of_rights'));
const hasConditions = computed(() => ctx.flag('has_conditions'));
</script>

<template>
  <div class="allot-doc">
    <p class="doc-sec-title" style="margin-bottom:2px">COMPANIES ACT 2016</p>
    <p class="doc-sec-title" style="margin-top:0;margin-bottom:2px">Section 76</p>
    <p class="doc-sec-title" style="margin-top:0">
      NOTICE OF APPROVAL FOR ALLOTMENT OF SHARES OR GRANT OF RIGHTS
    </p>

    <p class="doc-p" style="text-align:center;margin-top:12px">
      <BonusDocVarField field-key="company_name" />
    </p>

    <p class="doc-p">To the Registrar of Companies,</p>

    <p class="doc-p">
      <BonusDocVarField field-key="company_name" />
      [Company Registration No. <BonusDocVarField field-key="company_registration_no" />]
      hereby gives notice that on the <BonusDocVarField field-key="allotment_date" />,
      an allotment of
      <span
        class="doc-toggle"
        title="Toggle: shares ↔ grant of rights"
        @click="ctx.toggleFlag('grant_of_rights')"
      >{{ grant ? 'grant of rights' : 'shares' }}</span>
      has been approved.
      The approval is
      <span
        class="doc-toggle"
        title="Toggle: with / without conditions"
        @click="ctx.toggleFlag('has_conditions')"
      >{{
        hasConditions
          ? 'subject to the following conditions:'
          : 'not subject to any conditions'
      }}</span><template v-if="hasConditions">
        <BonusDocVarField field-key="conditions_text" />
      </template>.
    </p>

    <p class="doc-p">
      THAT pursuant to Section 75 of the Companies Act 2016, the Director(s) be and is/are hereby
      empowered to issue shares in the Company from time to time and upon such terms and conditions
      and for such purposes as the Director(s) may deem fit and that such authority shall continue
      in force until not more than twelve months after the approval is given by the members.
      Such new shares when fully paid will rank pari passu in all respects with existing shares
      in the Company.
    </p>

    <p class="doc-p">
      <b>Declaration:</b>
      I confirm that the facts and information stated in this document are true and to the best
      of my knowledge.
    </p>

    <p class="doc-lbl-title">Signed: Secretary</p>
    <table class="cdd-tbl">
      <tbody>
        <tr><td class="cdd-lcell">Name</td><td><BonusDocVarField field-key="secretary_name" /></td></tr>
        <tr><td>License / Membership No.</td><td><BonusDocVarField field-key="secretary_license_no" /></td></tr>
        <tr><td>SSM Practicing Certificate No.</td><td><BonusDocVarField field-key="secretary_sspc_no" /></td></tr>
        <tr><td>Date</td><td><BonusDocVarField field-key="signature_date" /></td></tr>
      </tbody>
    </table>

    <p class="doc-p" style="margin-top:18px;font-size:0.92em">
      <b>Attention:</b>
      It is an offence under section 591 of the Companies Act 2016 to make or authorize the making
      of a statement that a person knows is false or misleading and that person may be liable,
      upon conviction, to imprisonment for a term not exceeding ten years or to a fine not
      exceeding RM3 million or to both.
    </p>

    <p class="doc-lbl-title">LODGER INFORMATION</p>
    <table class="cdd-tbl">
      <tbody>
        <tr><td class="cdd-lcell">Name</td><td><BonusDocVarField field-key="lodger_name" /></td></tr>
        <tr><td>NRIC No.</td><td><BonusDocVarField field-key="lodger_nric" /></td></tr>
        <tr><td>Address</td><td><BonusDocVarField field-key="lodger_address" /></td></tr>
        <tr><td>Phone No.</td><td><BonusDocVarField field-key="lodger_phone" /></td></tr>
        <tr><td>Email</td><td><BonusDocVarField field-key="lodger_email" /></td></tr>
      </tbody>
    </table>
  </div>
</template>
